'use strict';

/** @type {import('./range')} */
module.exports = RangeError;



//////////////////
// WEBPACK FOOTER
// ./~/_es-errors@1.3.0@es-errors/range.js
// module id = 1369
// module chunks = 0